var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgProfessionalPlans = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M82 44.362v27.48a4.027 4.027 0 0 1-4.027 4.027H18.03A4.027 4.027 0 0 1 14 71.85V44.37"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M82 44.362v27.48a4.027 4.027 0 0 1-4.027 4.027H18.03A4.027 4.027 0 0 1 14 71.85V44.37"
  }), React.createElement("path", {
    stroke: color,
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.752 70.305h66.513"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M29.454 54.402h-9.791A5.667 5.667 0 0 1 14 48.735v-8.202a9.993 9.993 0 0 1 9.988-9.993h48.02A9.993 9.993 0 0 1 82 40.533v8.202a5.667 5.667 0 0 1-5.667 5.667h-8.599"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M29.454 54.402h-9.791A5.667 5.667 0 0 1 14 48.735v-8.202a9.993 9.993 0 0 1 9.988-9.993h48.02A9.993 9.993 0 0 1 82 40.533v8.202a5.667 5.667 0 0 1-5.667 5.667h-8.599"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M40.679 31.196v1.7a1.79 1.79 0 0 1-1.786 1.786h-2.379a1.79 1.79 0 0 1-1.786-1.786v-1.7M62.355 31.196v1.7a1.79 1.79 0 0 1-1.785 1.786h-2.38a1.79 1.79 0 0 1-1.785-1.786v-1.7M60.577 54.402H36.613"
  }), React.createElement("path", {
    fill: color,
    d: "M35.118 49.629h-4.166c-.826 0-1.496.67-1.496 1.496v7.745c0 .826.67 1.496 1.496 1.496h4.166c.827 0 1.497-.67 1.497-1.496v-7.745c0-.826-.67-1.496-1.497-1.496Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M59.332 30.54v-5.126A4.414 4.414 0 0 0 54.918 21H42.27a4.414 4.414 0 0 0-4.414 4.414v5.126"
  }), React.createElement("path", {
    fill: color,
    d: "M66.239 49.629h-4.166c-.827 0-1.497.67-1.497 1.496v7.745c0 .826.67 1.496 1.497 1.496h4.166c.826 0 1.496-.67 1.496-1.496v-7.745c0-.826-.67-1.496-1.496-1.496Z"
  }));
};
export default SvgProfessionalPlans;